// Schema definitions for ad hoc query builder
// NOTE: Field definitions should be populated from schema.xlsx
// Each table has fields with: fieldName, friendlyName, and dataType

export const TABLE_DEFINITIONS = {
  tblSapAth: {
    friendlyName: 'Authorizations',
    alias: 'auth',
    fields: [
      { fieldName: 'SapAthID', friendlyName: 'Authorization ID', dataType: 'int' },
      { fieldName: 'SapAthAdmDate', friendlyName: 'Admit Date', dataType: 'datetime' },
      { fieldName: 'SapAthDchDate', friendlyName: 'Discharge Date', dataType: 'datetime' },
      { fieldName: 'SapAth_EpdID', friendlyName: 'Episode ID', dataType: 'int' },
      { fieldName: 'SapAth_CboID', friendlyName: 'Provider ID', dataType: 'int' },
      { fieldName: 'SapAthAuthorizedUnits', friendlyName: 'Authorized Units', dataType: 'decimal' },
      { fieldName: 'SapAthEffectiveDate', friendlyName: 'Effective Date', dataType: 'datetime' },
      { fieldName: 'SapAthExpirationDate', friendlyName: 'Expiration Date', dataType: 'datetime' },
      { fieldName: 'SapAthAuthNumber', friendlyName: 'Authorization Number', dataType: 'string' },
      { fieldName: 'SapAthUnitsUsed', friendlyName: 'Units Used', dataType: 'decimal' },
      { fieldName: 'SapAthUnitsRemaining', friendlyName: 'Units Remaining', dataType: 'decimal' },
      { fieldName: 'SapAthStatusID', friendlyName: 'Status ID', dataType: 'int' },
      { fieldName: 'SapAthCreatedDate', friendlyName: 'Created Date', dataType: 'datetime' },
      { fieldName: 'SapAthModifiedDate', friendlyName: 'Modified Date', dataType: 'datetime' },
      { fieldName: 'SapAthStartDate', friendlyName: 'Start Date', dataType: 'datetime' },
      { fieldName: 'SapAthEndDate', friendlyName: 'End Date', dataType: 'datetime' },
    ]
  },
  tblEpd: {
    friendlyName: 'Episodes',
    alias: 'epd',
    fields: [
      { fieldName: 'EpdID', friendlyName: 'Episode ID', dataType: 'int' },
      { fieldName: 'Epd_PrtID', friendlyName: 'Participant ID', dataType: 'int' },
      { fieldName: 'EpdStartDate', friendlyName: 'Start Date', dataType: 'datetime' },
      { fieldName: 'EpdEndDate', friendlyName: 'End Date', dataType: 'datetime' },
      { fieldName: 'EpdAdmitDate', friendlyName: 'Admit Date', dataType: 'datetime' },
      { fieldName: 'EpdDischargeDate', friendlyName: 'Discharge Date', dataType: 'datetime' },
      { fieldName: 'EpdStatusID', friendlyName: 'Status ID', dataType: 'int' },
      { fieldName: 'EpdReferralDate', friendlyName: 'Referral Date', dataType: 'datetime' },
      { fieldName: 'EpdCDCNumber', friendlyName: 'CDC Number', dataType: 'string' },
      { fieldName: 'EpdCreatedDate', friendlyName: 'Created Date', dataType: 'datetime' },
      { fieldName: 'EpdModifiedDate', friendlyName: 'Modified Date', dataType: 'datetime' },
    ]
  },
  tblPrt: {
    friendlyName: 'Participants',
    alias: 'prt',
    fields: [
      { fieldName: 'PrtID', friendlyName: 'Participant ID', dataType: 'int' },
      { fieldName: 'PrtFName', friendlyName: 'First Name', dataType: 'string' },
      { fieldName: 'PrtLName', friendlyName: 'Last Name', dataType: 'string' },
      { fieldName: 'PrtMName', friendlyName: 'Middle Name', dataType: 'string' },
      { fieldName: 'PrtDOB', friendlyName: 'Date of Birth', dataType: 'datetime' },
      { fieldName: 'PrtSSN', friendlyName: 'SSN', dataType: 'string' },
      { fieldName: 'Prt_GndID', friendlyName: 'Gender ID', dataType: 'int' },
      { fieldName: 'PrtEthnicityID', friendlyName: 'Ethnicity ID', dataType: 'int' },
      { fieldName: 'PrtRaceID', friendlyName: 'Race ID', dataType: 'int' },
      { fieldName: 'PrtPhone', friendlyName: 'Phone', dataType: 'string' },
      { fieldName: 'PrtEmail', friendlyName: 'Email', dataType: 'string' },
      { fieldName: 'PrtAddress', friendlyName: 'Address', dataType: 'string' },
      { fieldName: 'PrtCity', friendlyName: 'City', dataType: 'string' },
      { fieldName: 'PrtState', friendlyName: 'State', dataType: 'string' },
      { fieldName: 'PrtZip', friendlyName: 'Zip Code', dataType: 'string' },
      { fieldName: 'PrtCreatedDate', friendlyName: 'Created Date', dataType: 'datetime' },
      { fieldName: 'PrtModifiedDate', friendlyName: 'Modified Date', dataType: 'datetime' },
      { fieldName: 'Prt290RegYN', friendlyName: '290 Registrant', dataType: 'boolean' },
      { fieldName: 'PrtVet', friendlyName: 'Veteran', dataType: 'boolean' },
    ]
  },
  tblCbo: {
    friendlyName: 'Providers',
    alias: 'cbo',
    fields: [
      { fieldName: 'CboID', friendlyName: 'Provider ID', dataType: 'int' },
      { fieldName: 'Cbo_ModID', friendlyName: 'Modality', dataType: 'string' },
      { fieldName: 'Cbo_OrgID', friendlyName: 'Organization ID', dataType: 'int' },
      { fieldName: 'CboName', friendlyName: 'Provider Name', dataType: 'string' },
      { fieldName: 'CboCode', friendlyName: 'Provider Code', dataType: 'string' },
      { fieldName: 'CboPhone', friendlyName: 'Phone', dataType: 'string' },
      { fieldName: 'CboFax', friendlyName: 'Fax', dataType: 'string' },
      { fieldName: 'CboEmail', friendlyName: 'Email', dataType: 'string' },
      { fieldName: 'CboAddress', friendlyName: 'Address', dataType: 'string' },
      { fieldName: 'CboCity', friendlyName: 'City', dataType: 'string' },
      { fieldName: 'CboState', friendlyName: 'State', dataType: 'string' },
      { fieldName: 'CboZip', friendlyName: 'Zip Code', dataType: 'string' },
      { fieldName: 'CboStatusID', friendlyName: 'Status ID', dataType: 'int' },
      { fieldName: 'CboCreatedDate', friendlyName: 'Created Date', dataType: 'datetime' },
      { fieldName: 'CboModifiedDate', friendlyName: 'Modified Date', dataType: 'datetime' },
      { fieldName: 'CboInactiveYN', friendlyName: 'Inactive', dataType: 'boolean' },
      { fieldName: 'CbpAcpt290', friendlyName: 'Accepts 290', dataType: 'boolean' },
    ]
  },
  tblOrg: {
    friendlyName: 'Organizations',
    alias: 'org',
    fields: [
      { fieldName: 'OrgID', friendlyName: 'Organization ID', dataType: 'int' },
      { fieldName: 'OrgName', friendlyName: 'Organization Name', dataType: 'string' },
      { fieldName: 'OrgCode', friendlyName: 'Organization Code', dataType: 'string' },
      { fieldName: 'OrgPhone', friendlyName: 'Phone', dataType: 'string' },
      { fieldName: 'OrgFax', friendlyName: 'Fax', dataType: 'string' },
      { fieldName: 'OrgEmail', friendlyName: 'Email', dataType: 'string' },
      { fieldName: 'OrgAddress', friendlyName: 'Address', dataType: 'string' },
      { fieldName: 'OrgCity', friendlyName: 'City', dataType: 'string' },
      { fieldName: 'OrgState', friendlyName: 'State', dataType: 'string' },
      { fieldName: 'OrgZip', friendlyName: 'Zip Code', dataType: 'string' },
      { fieldName: 'OrgTypeID', friendlyName: 'Type ID', dataType: 'int' },
      { fieldName: 'OrgStatusID', friendlyName: 'Status ID', dataType: 'int' },
      { fieldName: 'OrgCreatedDate', friendlyName: 'Created Date', dataType: 'datetime' },
      { fieldName: 'OrgModifiedDate', friendlyName: 'Modified Date', dataType: 'datetime' },
    ]
  }
};

/**
 * Table relationships for dynamic JOIN generation
 * Each entry defines a direct foreign key relationship between two tables
 * The relationship can be traversed in either direction
 */
export const TABLE_RELATIONSHIPS = [
  {
    // Authorizations → Episodes
    table1: 'tblSapAth',
    table2: 'tblEpd',
    joinCondition: 'tblSapAth.SapAth_EpdID = tblEpd.EpdID'
  },
  {
    // Authorizations → Providers
    table1: 'tblSapAth',
    table2: 'tblCbo',
    joinCondition: 'tblSapAth.SapAth_CboID = tblCbo.CboID'
  },
  {
    // Episodes → Participants
    table1: 'tblEpd',
    table2: 'tblPrt',
    joinCondition: 'tblEpd.Epd_PrtID = tblPrt.PrtID'
  },
  {
    // Episodes → Providers
    table1: 'tblEpd',
    table2: 'tblCbo',
    joinCondition: 'tblEpd.Epd_CboID = tblCbo.CboID'
  },
  {
    // Providers → Organizations
    table1: 'tblCbo',
    table2: 'tblOrg',
    joinCondition: 'tblCbo.Cbo_OrgID = tblOrg.OrgID'
  }
];

/**
 * DEPRECATED: This static join string has been replaced with dynamic JOIN generation
 * See buildFromClause() in sqlGenerator.js and TABLE_RELATIONSHIPS above
 * Kept for reference only
 */
// export const PREDEFINED_JOINS = `tblSapAth
// INNER JOIN tblEpd ON tblSapAth.SapAth_EpdID = tblEpd.EpdID
// INNER JOIN tblPrt ON tblEpd.Epd_PrtID = tblPrt.PrtID
// INNER JOIN tblCbo ON tblSapAth.SapAth_CboID = tblCbo.CboID
// INNER JOIN tblOrg ON tblCbo.Cbo_OrgID = tblOrg.OrgID`;

// Get list of all tables with friendly names for dropdown
export const getTableOptions = () => {
  return Object.keys(TABLE_DEFINITIONS).map(tableName => ({
    value: tableName,
    label: TABLE_DEFINITIONS[tableName].friendlyName
  }));
};

// Get fields for a specific table
export const getFieldsForTable = (tableName) => {
  if (!tableName || !TABLE_DEFINITIONS[tableName]) {
    return [];
  }

  return TABLE_DEFINITIONS[tableName].fields.map(field => ({
    value: field.fieldName,
    label: field.friendlyName,
    dataType: field.dataType
  }));
};

// Get field metadata
export const getFieldMetadata = (tableName, fieldName) => {
  if (!tableName || !fieldName || !TABLE_DEFINITIONS[tableName]) {
    return null;
  }

  return TABLE_DEFINITIONS[tableName].fields.find(
    field => field.fieldName === fieldName
  );
};

// Operator definitions
export const OPERATORS = [
  { value: 'equals', label: 'Equals', requiresCriteria: true, supportsDataTypes: ['boolean','int', 'decimal', 'string', 'datetime'] },
  { value: 'notEquals', label: 'Not Equals', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'string', 'datetime'] },
  { value: 'greaterThan', label: 'Greater Than', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'datetime'] },
  { value: 'lessThan', label: 'Less Than', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'datetime'] },
  { value: 'greaterThanOrEqual', label: 'Greater Than or Equal', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'datetime'] },
  { value: 'lessThanOrEqual', label: 'Less Than or Equal', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'datetime'] },
  { value: 'contains', label: 'Contains', requiresCriteria: true, supportsDataTypes: ['string'] },
  { value: 'startsWith', label: 'Starts With', requiresCriteria: true, supportsDataTypes: ['string'] },
  { value: 'endsWith', label: 'Ends With', requiresCriteria: true, supportsDataTypes: ['string'] },
  { value: 'between', label: 'Between', requiresCriteria: true, supportsDataTypes: ['int', 'decimal', 'datetime'] },
  { value: 'in', label: 'In', requiresCriteria: true, supportsDataTypes: ['int', 'string'] },
  { value: 'isNull', label: 'Is Null', requiresCriteria: false, supportsDataTypes: ['int', 'decimal', 'string', 'datetime'] },
  { value: 'isNotNull', label: 'Is Not Null', requiresCriteria: false, supportsDataTypes: ['int', 'decimal', 'string', 'datetime'] }
];

// Get operators for a specific data type
export const getOperatorsForDataType = (dataType) => {
  if (!dataType) {
    return OPERATORS;
  }

  return OPERATORS.filter(op =>
    op.supportsDataTypes.includes(dataType)
  );
};
